<template lang="pug">
v-toolbar.main--toolbar.bi-toolbar(height="56" app fixed dense dark Zclass="'grey'" :clipped-left="$vuetify.breakpoint.lgAndUp")
  v-toolbar-title
    v-toolbar-side-icon(@click.stop="toggleDrawer")
    span.brand-logo(@click="home")
      img.logo-icon(src='/static/kazzinc_tj.svg')

  v-text-field.hidden-sm-and-down(solo-inverted flat
    :label="$tf('drawer.process.search')",
    v-model="search",
    clearable
    Zfull-width
    single-line
    hide-details
    height="30"
    readonly
    style="width: 400px; margin-left:62px;"
    @click="$router.push('/process-search')"
    append-icon="search"
  )
  //- v-toolbar-items
    //- v-btn(flat to="/task-list")  {{ $tf("drawer.task.title") }}
    //- v-btn.ml-3(flat to="/process-search")  {{ $tf("drawer.process.search") }}
    //- v-btn(flat to="/report-list")  {{ $tf("drawer.report.title") }}

  v-spacer
  // v-menu(:nudge-width="100")
    template(v-slot:activator="{ on }")
      v-btn(icon v-on="on")
        v-icon more_vert
    v-list
      v-list-tile
        v-list-tile-title Загрузить
  //- v-btn(icon)
    v-icon more_vert
    //- v-btn(icon)
      v-icon apps

  v-card-title.px-0
    v-menu
      v-btn.pr-0(slot="activator" flat dark)
        v-icon language
        .ml-2.mr-1 {{ getLocale() }}
        v-icon keyboard_arrow_down
      v-list
        v-list-tile(v-for="(lang, i) in languages" :key="i" @click="changeLocale(lang.locale)")
          v-list-tile-title {{ lang.label }}

</template>
<script>
import { changeLocale, getLocale } from '@/i18n'
import { mapActions } from 'vuex'

export default {
  name: 'Toolbar',

  data: function() {
    return {
      search: null,
      languages: [
        {
          locale: 'kk',
          label: 'Қазақша',
        },
        {
          locale: 'ru',
          label: 'Русский',
        }
      ],
    }
  },

  created() {
    // Mini bootloaders
    changeLocale()
    this.setAppLoaded(true)
  },

  methods: {
    ...mapActions({
      toggleDrawer: 'tools/toggleDrawer',
      setAppLoaded: 'tools/setAppLoaded',
    }),

    home() {
      this.$router.push('/')
    },

    getLocale() {
      const current = this.languages.find(lang => lang.locale === getLocale())
      return `${current.label} (${current.locale})`
    },

    changeLocale(locale) {
      changeLocale(locale)
    },
  },
}
</script>
<style lang="stylus">
.brand-logo
  cursor pointer
  height 36px

  .logo-name
    vertical-align middle
    font-size 24px
    letter-spacing -0.5px
  .logo-icon
    vertical-align middle
    height 34px
    // margin-left 10px
    // margin-top -9px

.bi-toolbar
  .v-toolbar__content
    padding 0 6px
  .v-text-field.v-text-field--solo .v-input__control
    min-height 42px


</style>



// WEBPACK FOOTER //
// src/components/utils/Toolbar.vue